import { validateFieldForRequired } from 'libs/validator';

export const PAYMENT_INFO_KEYS = {
  FULL_NAME: 'full_name',
  CARD_NUMBER: 'number',
  EXPIRY_DATE: 'expiry',
  CVV: 'cvv'
};

export const ERROR_INFO_KEYS = {
  PAYMENT_FORM: 'paymentForm'
};

export const PAYMENT_ERROR_CONFIG = {
  errorKey: ERROR_INFO_KEYS.PAYMENT_FORM,
  errorFields: [PAYMENT_INFO_KEYS.FULL_NAME]
};

export function checkErrors(errorFields = [], paymentInfo = {}) {
  const errors = {};

  if (errorFields.indexOf(PAYMENT_INFO_KEYS.FULL_NAME) !== -1) {
    const fullNameError = validateFieldForRequired(
      paymentInfo[PAYMENT_INFO_KEYS.FULL_NAME]
    );
    if (fullNameError) {
      errors[PAYMENT_INFO_KEYS.FULL_NAME] = fullNameError;
    }
  }
  return errors;
}

export default {
  PAYMENT_INFO_KEYS
};



// WEBPACK FOOTER //
// ./src/views/SubscriptionActivate/Payment/config.js